// Filter Compancy

const filters = document.querySelectorAll(".js-competency-filter");

const resetButtons = function (filters) {
	filters.forEach((filter) => {
		filter.classList.remove("is-active");
	});
};

const filterItems = function (filter) {
	filter.classList.add("is-active");

	let selectedFilter = filter.getAttribute("data-filter");
	let allItems = document.querySelectorAll(".service-cards .service-card[data-filter]");

	if (selectedFilter == "Alle") {
		allItems.forEach((el) => {
			el.classList.remove("hide");
			el.classList.add("show");
		});
		return;
	}

	// Check each item to see if it contains the selected filter value
	allItems.forEach((el) => {
		let itemFilters = el.getAttribute("data-filter");
		// Split by spaces and check if the selected filter is in the array
		let filterArray = itemFilters ? itemFilters.split(/\s+/) : [];
		let hasFilter = filterArray.includes(selectedFilter);

		if (hasFilter) {
			el.classList.remove("hide");
			el.classList.add("show");
		} else {
			el.classList.add("hide");
			el.classList.remove("show");
		}
	});
};

filters.forEach((filter) => {
	filter.addEventListener("click", function () {
		resetButtons(filters);
		filterItems(filter);
	});
});
